import { render, staticRenderFns } from "./WhatsHappeningEntryJoinButton.vue?vue&type=template&id=6f8ede12&"
import script from "./WhatsHappeningEntryJoinButton.vue?vue&type=script&lang=js&"
export * from "./WhatsHappeningEntryJoinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports